<template>
  <div class="lv-list-box">
    <Header :pageTitle="columnName" />
    <ListDropdown
      :dropdownValue="dropdownValue"
      :dropdownOption="dropdownoption"
      :total="total"
      @getDropdownValue="getDropdownValue"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="lv-list" v-if="loading || articleList.length > 0">
        <ZzItem
          class="lv-list-item"
          v-for="item in articleList"
          :key="item.articleId"
          :cover="item.cover"
          :title="item.title"
          :artSummary="item.artSummary"
          :author="
            item.authorResultList.length > 1
              ? `${item.authorResultList[0].authorName}等`
              : item.authorResultList[0]
              ? item.authorResultList[0].authorName
              : ''
          "
          @click.native="toDetail(item.articleId)"
        />
      </div>
      <noneList noneType="zzList" v-else />
    </van-list>
  </div>
</template>
    
    <script>
import Header from "@/views/mobileView/components/header";
import ListDropdown from "@/views/mobileView/components/header/listDropdown";
import ZzItem from "@/views/mobileView/components/listItem/zzItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "AcademicMonograph",
  components: {
    Header,
    ListDropdown,
    ZzItem,
    noneList,
  },
  data() {
    return {
      columnName: "",
      dropdownValue: "0",
      dropdownoption: [{ text: "全部", value: "0" }],
      params: {
        pageNo: 0,
        pageSize: 10,
        channelId1: 6,
        classifyNumber: "",
        beginDateTime: "",
        projectId: 1,
      },
      total: 0,
      articleList: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  created() {
    this.getColumnName();
    this.getDropdownOption();
  },
  methods: {
    // 获取栏目名称 (专著id为6)
    async getColumnName() {
      const resp = await this.$apis.searchServe.getNavList();
      resp.data.forEach((item) => {
        if (item.id === "6") this.columnName = item.columnName;
      });
    },
    // 获取筛选列表
    async getDropdownOption() {
      const res = await this.$apis.mainServe.classificationOneList();
      let optionsArr = res.classOneList.map((item) => {
        return {
          text: item.classifyName,
          value: item.classifyNumber,
        };
      });
      this.dropdownoption.push(...optionsArr);
    },
    // 获取选中列表筛选项
    getDropdownValue(value) {
      if (value === "0") {
        this.params.classifyNumber = "";
      } else {
        this.params.classifyNumber = value;
      }
      this.dropdownValue = value;
      this.params.pageNo = 1;
      this.articleList = [];
      this.getList();
    },
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      if (this.params.pageNo == 1) {
        this.params.beginDateTime = this.$global.transferDate(new Date());
      }
      const resp = await this.$apis.mainServe.getListByChannel(this.params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 10;
        this.articleList.push(...resp.data.list);
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      this.$router.push({
        name: "concentrationDetails",
        query: {
          id,
          type: 2,
        },
      });
    },
  },
};
</script>
    
    <style scoped lang="scss">
.lv-list-box {
  padding-top: 44px;
  padding-bottom: 12px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .tab-box {
    margin: 12px 12px;
    .tab-item {
      margin-right: 12px;
      display: inline-block;
      padding: 0 13px;
      height: 30px;
      line-height: 30px;
      background-color: #fff;
      border-radius: 15px;
      font-size: 15px;
      color: #333333;
    }
    .tab-item-active {
      background-color: #4a79f1;
      color: #fff;
    }
  }
  .lv-list {
    margin: 12px auto 0;
    width: 351px;
    padding: 0 13px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .lv-list-item {
      border-bottom: 1px solid #eee;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>